import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["overlay", "sidebar"]

  open() {
    // Find the overlay either as a target or by ID (for Turbo compatibility)
    const overlay = this.hasOverlayTarget
      ? this.overlayTarget
      : document.getElementById("mobile-sidebar-overlay")

    if (overlay) {
      overlay.classList.remove("hidden")
    }
  }

  close() {
    // Find the overlay either as a target or by ID (for Turbo compatibility)
    const overlay = this.hasOverlayTarget
      ? this.overlayTarget
      : document.getElementById("mobile-sidebar-overlay")

    if (overlay) {
      overlay.classList.add("hidden")
    }
  }
}
